<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="GongYingShangList" data-title="采购管理">
      <li
        v-if="state.select_count > 0"
        class="text-sm text-gray-400 flex items-center"
      >
        已选
        <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
        条数据
        <el-button type="danger" link @click="onClearSelect"> 清空 </el-button>
      </li>
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <!-- <el-button
        type="primary"
        icon="Money"
        :disabled="!state.select_count > 0"
        @click="onFuKuan()"
      >
        申请付款
      </el-button> -->
      <el-button
        type="warning"
        icon="Switch"
        :disabled="!state.select_count > 0"
        @click="
          delete state.selectId;
          state.showChongXiao = true;
        "
        style="margin-left: -5px"
      >
        预付冲销
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white p-4 rounded-lg">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        ref="tableDom"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" reserve-selection />
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="200">
          <template #header>
            <div
              class="c-table-col-header"
              label1="采购名称"
              label2="采购单号/类型/创建人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.name }}</strong>
                <text class="text-xs text-gray-400 ml-1">{{ row.number }}</text>
              </template>
              <template #bottom>
                <div
                  class="flex items-center text-gray-400 text-xs gap-x-2 mt-2"
                >
                  <text>{{ row.d_cost_type_pname }}</text>
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column :min-width="160">
          <template #header>
            <div
              class="c-table-col-header"
              label1="所属会议"
              label2="状态/项目编号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.meeting?.name" :value2="row.number">
              <template #bottom>
                <div class="flex gap-x-2 items-center">
                  <c_status
                    arrName="Meeting_Status"
                    :value="row.meeting?.status"
                    :key="row.meeting?.status"
                  />
                  <text class="text-xs text-gray-400">{{
                    row.meeting?.number
                  }}</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="160"
          prop="intro"
          label="采购说明"
          :formatter="$tab_TextFormat"
        />
        <!-- <el-table-column :min-width="160">
          <template #header>
            <div
              class="c-table-col-header"
              label1="付款申请状态"
              label2="申请单号"
            />
          </template>
          <template #default="{ row }">
            <text>-</text>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="amount"
          label="采购价"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="paid_amount"
          label="已付"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column
          prop="unpaid_amount"
          label="应付"
          :formatter="$tab_PriceFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="120">
          <template #default="{ row }">
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="采购详情"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    width="70%"
  >
    <c_detail :id="state.selectId" />
  </el-dialog>
  <el-dialog
    v-model="state.showFuKuan"
    title="采购付款"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showFuKuan = false;
      }
    "
  >
    <c_fukuan
      :ids="state.select_ids"
      :supplier_id="props.supplier_id"
      @confirm="
        state.showFuKuan = false;
        onLoad();
      "
    />
  </el-dialog>
  <el-dialog
    v-model="state.showChongXiao"
    title="预付冲销"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showChongXiao = false;
      }
    "
    width="70%"
  >
    <c_chongxiao
      :ids="state.select_ids"
      :supplier_id="props.supplier_id"
      @close="
        state.showChongXiao = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { supplier_purchase_page } from "@/http/supplier";
import { ElMessage } from "element-plus";

import c_detail from "./Detail.vue";
import c_fukuan from "./FuKuan.vue";
import c_chongxiao from "./ChongXiao.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    supplier_id: Number,
  },
  components: {
    c_detail,
    c_fukuan,
    c_chongxiao,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.supplier_id = props.supplier_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      supplier_purchase_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
      state.select_ids = e.map((m) => m.id);
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    //付款申请
    const onFuKuan = () => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }

      const meeting_ids = rows.reduce((pre, cur) => {
        if (!pre.includes(cur.meeting_id)) pre.push(cur.meeting_id);
        return pre;
      }, []);
      if (meeting_ids.length > 1) {
        ElMessage.warning("只能选择同一会议的采购单！");
        return;
      } else {
        delete state.selectId;
        state.showFuKuan = true;
      }
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onSelectChange,
      onClearSelect,
      onRowClick,
      onFuKuan,
    };
  },
};
</script>

<style lang="scss" scoped></style>
